import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createSelector } from 'reselect';
import { injectIntl } from "react-intl";
import { setOpenAdvanceFiltersDialog } from '../../store/actions/pages';
import DataTableHeaderComponent, { Field } from './DataTableHeader';
import { selectDefaultCustomFilters } from '../../store/selectors/claimAnalysis';

export const DataTableHeader : React.FC<{
    fields: Field[];
    intl: any;
    onFilterChange: (newFilter: any, isAddFilter: boolean) => void;
    onFilterDelete: (f: any, index: number) => void;
    pending: boolean;
    customFilter: any[];
    pageName: string;
    onFilterClear: () => void;
    userSessionId?:string;
    significance?: boolean;
    filter: any[];
    onFilterSave: (criteria: any, handleClose: () => void, existingCriteria: any) => void;
    filterSaveState?: any;
    criteria: any;
    saveEnabled: boolean; 
    onFilterUpdate: (newFilterObj: any, updatingFieldIndex: number | null, isAddFilter: boolean) => void;
}> = connect(
    () => {
        return (state:any, props) => ({
            openFiltersPanel: state.pages.open,
            anchorEl: state.pages.anchorEl,
            defaultCustomFilters: selectDefaultCustomFilters(state, props),
            filtersAnchorEl: state.pages.filtersAnchorEl,
        });
    },
    (dispatch, props) => ({
        actions: bindActionCreators({
            setOpenAdvanceFiltersDialog
        }, dispatch)
    })
)(injectIntl(DataTableHeaderComponent as any));